import { render, staticRenderFns } from "./garbageStationSorter.vue?vue&type=template&id=dab663e8&scoped=true&"
import script from "./garbageStationSorter.vue?vue&type=script&lang=js&"
export * from "./garbageStationSorter.vue?vue&type=script&lang=js&"
import style0 from "./garbageStationSorter.vue?vue&type=style&index=0&id=dab663e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab663e8",
  null
  
)

export default component.exports